<template>
  <div class="library-page">
    <header class="page-header">
      <div>
        <span class="page-kicker">{{ publicOnly ? '发现下一本' : '你的阅读空间' }}</span>
        <h1>{{ publicOnly ? '公共书库' : '我的书库' }}</h1>
        <p>{{ publicOnly ? '浏览大家分享的书籍，按主题找到下一本想读的故事。' : '你的私有书和收藏在这里；已公开的书去公共书库浏览。' }}</p>
      </div>
      <div class="header-actions">
        <button class="btn" type="button" @click="$router.push({ name: 'Search', query: { scope: publicOnly ? 'public' : 'mine' } })">
          <nricon name="search" :size="18" /><span>搜索</span>
        </button>
        <router-link v-if="!publicOnly" class="btn btn--primary" to="/upload"><nricon name="plus" :size="18" /><span>添加内容</span></router-link>
      </div>
    </header>

    <section class="filter-panel" aria-label="书库筛选">
      <div class="filter-row media-row">
        <span class="filter-label">媒介</span>
        <div class="chips" role="group" aria-label="媒介类型">
          <button v-for="item in mediaOptions" :key="item.value" type="button" class="filter-chip" :class="{ active: mediaType === item.value }" :aria-pressed="mediaType === item.value" @click="changeFilter('mediaType', item.value)">{{ item.label }}</button>
        </div>
      </div>
      <button class="mobile-filter-button" type="button" :aria-expanded="filtersOpen ? 'true' : 'false'" @click="filtersOpen = true"><nricon name="setting" :size="16" />更多筛选<span v-if="activeFilterCount" class="filter-count">{{ activeFilterCount }}</span></button>
      <div v-if="!publicOnly" class="filter-row source-row">
        <span class="filter-label">来源</span>
        <div class="chips" role="group" aria-label="来源">
          <button v-for="item in sourceOptions" :key="item.value" type="button" class="filter-chip" :class="{ active: source === item.value }" :aria-pressed="source === item.value" @click="changeFilter('source', item.value)">{{ item.label }}</button>
        </div>
      </div>
      <div v-if="isLoggedIn" class="filter-row">
        <span class="filter-label">阅读状态</span>
        <div class="chips status-chips" role="group" aria-label="阅读状态">
          <button v-for="item in statusOptions" :key="item.value" type="button" class="filter-chip" :class="{ active: status === item.value }" :aria-pressed="status === item.value" @click="changeFilter('status', item.value)">{{ item.label }}</button>
        </div>
      </div>
      <div class="filter-row filter-selects">
        <label class="select-field">
          <span class="filter-label">分类</span>
          <select class="nr-select" :value="category" @change="changeFilter('category', $event.target.value)">
            <option value="">全部分类</option>
            <option v-for="item in categories" :key="item" :value="item">{{ item }}</option>
          </select>
        </label>
        <label v-if="!publicOnly && source === 'uploads'" class="select-field">
          <span class="filter-label">可见性</span>
          <select class="nr-select" :value="visibilitySelect" @change="changeFilter('visibility', $event.target.value)">
            <option value="PRIVATE">私有</option><option value="PUBLIC">公开</option>
          </select>
        </label>
        <label class="select-field sort-field">
          <span class="filter-label">排序</span>
          <select class="nr-select" :value="sort" @change="changeFilter('sort', $event.target.value)">
            <option value="added">最近添加</option><option value="used">最近使用</option>
          </select>
        </label>
        <div class="filter-spacer"></div>
        <div class="view-switch" role="group" aria-label="显示方式">
          <button type="button" :class="{ active: viewMode === 'grid' }" aria-label="网格视图" :aria-pressed="viewMode === 'grid'" @click="changeFilter('view', 'grid')"><nricon name="menu" /></button>
          <button type="button" :class="{ active: viewMode === 'list' }" aria-label="列表视图" :aria-pressed="viewMode === 'list'" @click="changeFilter('view', 'list')"><nricon name="tickets" /></button>
        </div>
      </div>
    </section>

    <div v-if="filtersOpen" class="mobile-filter-backdrop" @click.self="filtersOpen = false">
      <section ref="mobileFilterSheet" class="mobile-filter-sheet" role="dialog" aria-modal="true" aria-label="书库筛选" tabindex="-1" @keydown="onMobileFilterKeydown">
        <header><div><span>精简结果</span><h2>筛选内容</h2></div><button type="button" aria-label="关闭筛选" @click="filtersOpen = false"><nricon name="close" /></button></header>
        <div v-if="!publicOnly" class="sheet-filter-group"><strong>来源</strong><div class="chips" role="group" aria-label="来源">
          <button v-for="item in sourceOptions" :key="item.value" type="button" class="filter-chip" :class="{ active: source === item.value }" :aria-pressed="source === item.value" @click="changeFilter('source', item.value)">{{ item.label }}</button>
        </div></div>
        <div v-if="isLoggedIn" class="sheet-filter-group"><strong>阅读状态</strong><div class="chips" role="group" aria-label="阅读状态">
          <button v-for="item in statusOptions" :key="item.value" type="button" class="filter-chip" :class="{ active: status === item.value }" :aria-pressed="status === item.value" @click="changeFilter('status', item.value)">{{ item.label }}</button>
        </div></div>
        <div class="sheet-selects">
          <label class="select-field"><span>分类</span><select class="nr-select" :value="category" @change="changeFilter('category', $event.target.value)"><option value="">全部分类</option><option v-for="item in categories" :key="item" :value="item">{{ item }}</option></select></label>
          <label v-if="!publicOnly && source === 'uploads'" class="select-field"><span>可见性</span><select class="nr-select" :value="visibilitySelect" @change="changeFilter('visibility', $event.target.value)"><option value="PRIVATE">私有</option><option value="PUBLIC">公开</option></select></label>
          <label class="select-field"><span>排序</span><select class="nr-select" :value="sort" @change="changeFilter('sort', $event.target.value)"><option value="added">最近添加</option><option value="used">最近使用</option></select></label>
        </div>
        <footer><button class="btn" type="button" @click="clearFilters">清空条件</button><button class="btn btn--primary" type="button" @click="filtersOpen = false">完成<span v-if="total"> · {{ total }} 项</span></button></footer>
      </section>
    </div>

    <div class="results-bar">
      <span>{{ loading ? '正在载入…' : `${total} 项内容` }}</span>
      <button v-if="hasFilters" class="clear-filters" type="button" @click="clearFilters">清除筛选</button>
    </div>

    <div v-if="loading && !books.length" class="library-grid skeletons" aria-label="正在载入书库" aria-busy="true">
      <div v-for="n in 8" :key="n" class="cover-skeleton"><span></span><i></i><i></i></div>
    </div>
    <div v-else-if="error" class="state-panel error-state">
      <nricon name="warning" :size="22" />
      <div><strong>书库载入失败</strong><p>{{ errorMessage }}</p></div>
      <button class="btn btn--sm" type="button" @click="loadBooks">重试</button>
    </div>
    <div v-else-if="!books.length" class="state-panel empty-state">
      <span class="empty-mark"><nricon name="collection" :size="24" /></span>
      <div><strong>{{ emptyTitle }}</strong><p>{{ emptyDescription }}</p></div>
      <router-link v-if="!publicOnly && source !== 'favorites'" class="btn btn--primary btn--sm" to="/upload">添加内容</router-link>
      <router-link v-if="!publicOnly" class="btn btn--sm" to="/discover">逛公共书库</router-link>
      <router-link v-else class="btn btn--sm" to="/search?scope=public">搜索书籍</router-link>
    </div>
    <div v-else class="library-grid" :class="viewMode === 'list' ? 'as-list' : 'as-grid'">
      <book-card
        v-for="book in books"
        :key="book.id"
        :book="book"
        :view-mode="viewMode"
        :show-visibility="!publicOnly && source === 'uploads'"
        :can-edit="canEdit"
        :can-remove="canRemove"
        :go-to-detail="goToDetail"
        :handle-edit="openEditor"
        :handle-delete="deleteBook"
        :handle-remove="removeFromLibrary"
      />
    </div>

    <nav v-if="totalPages > 1" class="pager" aria-label="书库分页">
      <button class="pager-arrow" type="button" :disabled="page <= 1" aria-label="上一页" @click="changePage(page - 1)"><nricon name="arrow-left" /></button>
      <button v-for="number in visiblePages" :key="number" type="button" :class="{ active: number === page }" :aria-current="number === page ? 'page' : null" @click="changePage(number)">{{ number }}</button>
      <button class="pager-arrow" type="button" :disabled="page >= totalPages" aria-label="下一页" @click="changePage(page + 1)"><nricon name="arrow-right" /></button>
    </nav>

    <book-editor v-if="editDialogVisible" :visible.sync="editDialogVisible" :book="currentBook || {}" @success="onEditSuccess" @close="editDialogVisible = false" />
  </div>
</template>

<script>
import api from '@/api'
import BookCard from '@/views/Book.vue'
import BookEditor from '@/components/book/BookEditor.vue'
import { CATEGORIES } from '@/utils/categories'
import { cleanTitle } from '@/utils/title'

const STATUSES = ['', 'unread', 'reading', 'completed']
const SOURCES = ['all', 'uploads', 'favorites']
const SORTS = ['added', 'used']

export default {
  name: 'LibraryPage',
  components: { BookCard, BookEditor },
  props: { publicOnly: { type: Boolean, default: false } },
  data() {
    return {
      source: 'all', status: '', category: '', visibility: '', mediaType: '', sort: 'used', viewMode: 'grid', keyword: '',
      filtersOpen: false, _previousBodyOverflow: '',
      books: [], total: 0, page: 1, pageSize: 24, loading: false, error: false, errorMessage: '',
      categories: CATEGORIES, editDialogVisible: false, currentBook: null,
      sourceOptions: [{ value: 'all', label: '全部' }, { value: 'uploads', label: '我的上传' }, { value: 'favorites', label: '我的收藏' }],
      statusOptions: [{ value: '', label: '全部' }, { value: 'unread', label: '未开始' }, { value: 'reading', label: '进行中' }, { value: 'completed', label: '已完成' }],
      mediaOptions: [{ value: '', label: '全部媒介' }, { value: 'TEXT', label: '电子书' }, { value: 'PDF', label: 'PDF' }, { value: 'AUDIO', label: '有声书' }]
    }
  },
  computed: {
    hasFilters() { return !!(this.status || this.category || this.visibility || this.mediaType || this.keyword || (!this.publicOnly && this.source !== 'all')) },
    activeFilterCount() { return [this.status, this.category, this.visibility, this.mediaType, !this.publicOnly && this.source !== 'all' ? this.source : ''].filter(Boolean).length + (this.sort !== this.defaultSort ? 1 : 0) },
    defaultSort() { return this.isLoggedIn && !this.publicOnly ? 'used' : 'added' },
    isLoggedIn() { return !!this.$store.state.token },
    // 「我的上传」的可见性下拉：未显式选择时按默认私有展示，避免下拉出现空白项
    visibilitySelect() { return this.visibility === 'PUBLIC' ? 'PUBLIC' : 'PRIVATE' },
    totalPages() { return Math.max(1, Math.ceil(this.total / this.pageSize)) },
    visiblePages() {
      const first = Math.max(1, Math.min(this.page - 2, this.totalPages - 4))
      const last = Math.min(this.totalPages, first + 4)
      const pages = []
      for (let p = first; p <= last; p++) pages.push(p)
      return pages
    },
    emptyTitle() {
      if (this.publicOnly) return '还没有公开内容'
      if (this.source === 'favorites') return '还没有收藏的书'
      if (this.status) return '没有符合条件的内容'
      return '书库还是空的'
    },
    emptyDescription() {
      if (this.publicOnly) return '新加入的公开书籍会显示在这里。'
      if (this.source === 'favorites') return '去公共书库收藏一本喜欢的书。'
      if (this.status) return '试试清除筛选，或查看其他阅读状态。'
      return '私有书和你的收藏会出现在这里；已公开的书统一在公共书库浏览。'
    }
  },
  watch: {
    filtersOpen(value) {
      if (value) {
        this._previousBodyOverflow = document.body.style.overflow
        document.body.style.overflow = 'hidden'
        document.addEventListener('keydown', this.onMobileFilterKeydown)
        this.$nextTick(() => { if (this.$refs.mobileFilterSheet) this.$refs.mobileFilterSheet.focus() })
      } else {
        document.body.style.overflow = this._previousBodyOverflow
        document.removeEventListener('keydown', this.onMobileFilterKeydown)
        this.$nextTick(() => { const button = this.$el.querySelector('.mobile-filter-button'); if (button) button.focus() })
      }
    },
    '$route.fullPath': {
      handler() { this.readQuery(); this.loadBooks() },
      immediate: true
    },
    publicOnly() { this.readQuery(); this.loadBooks() }
  },
  beforeRouteLeave(to, from, next) {
    this.filtersOpen = false
    sessionStorage.setItem(`library-scroll:${from.path}`, String(window.scrollY || 0))
    next()
  },
  mounted() {
    const saved = Number(sessionStorage.getItem(`library-scroll:${this.$route.path}`))
    if (saved > 0) this.$nextTick(() => window.scrollTo(0, saved))
  },
  beforeDestroy() {
    document.body.style.overflow = this._previousBodyOverflow
    document.removeEventListener('keydown', this.onMobileFilterKeydown)
  },
  methods: {
    onMobileFilterKeydown(event) {
      if (!this.filtersOpen) return
      if (event.key === 'Escape') { event.preventDefault(); this.filtersOpen = false; return }
      if (event.key !== 'Tab' || !this.$refs.mobileFilterSheet) return
      const focusable = [...this.$refs.mobileFilterSheet.querySelectorAll('button:not(:disabled), select, input, [tabindex="0"]')]
      if (!focusable.length) return
      const first = focusable[0]; const last = focusable[focusable.length - 1]
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus() }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus() }
    },
    readQuery() {
      const q = this.$route.query || {}
      if (!this.publicOnly) this.source = SOURCES.includes(q.source) ? q.source : 'all'
      this.status = STATUSES.includes(q.status) ? (q.status || '') : ''
      this.category = q.category || ''
      this.mediaType = ['TEXT', 'PDF', 'AUDIO'].includes(q.mediaType) ? q.mediaType : ''
      // 私有即「我的上传」默认值，不进 URL，也不计入筛选条件
      this.visibility = q.visibility === 'PUBLIC' ? 'PUBLIC' : ''
      this.sort = SORTS.includes(q.sort) ? q.sort : this.defaultSort
      this.viewMode = q.view === 'list' ? 'list' : 'grid'
      this.keyword = q.keyword || ''
      this.page = Math.max(1, parseInt(q.page, 10) || 1)
      if (this.publicOnly) this.source = 'all'
    },
    queryValue(value, fallback) { return value && value !== fallback ? value : undefined },
    changeFilter(key, value) {
      const next = { ...this.$route.query }
      if (key === 'source') { this.source = value; if (value !== 'uploads') this.visibility = '' }
      if (key === 'status') this.status = value
      if (key === 'category') this.category = value
      if (key === 'mediaType') this.mediaType = value
      if (key === 'visibility') this.visibility = value === 'PUBLIC' ? 'PUBLIC' : ''
      if (key === 'sort') this.sort = value
      if (key === 'view') this.viewMode = value
      if (key === 'keyword') this.keyword = value
      if (key !== 'view') next.page = undefined
      if (key === 'source') {
        next.source = value === 'all' ? undefined : value
        // 离开「我的上传」时把可见性一并从 URL 清掉，否则 readQuery 会把上面清空的
        // this.visibility 又读回来，切回来时筛选条件凭空复原。
        if (value !== 'uploads') next.visibility = undefined
      } else if (key === 'status') next.status = value || undefined
      else if (key === 'category') next.category = value || undefined
      else if (key === 'mediaType') next.mediaType = value || undefined
      else if (key === 'visibility') next.visibility = value === 'PUBLIC' ? 'PUBLIC' : undefined
      else if (key === 'sort') next.sort = value === 'used' ? undefined : value
      else if (key === 'view') next.view = value === 'grid' ? undefined : value
      else if (key === 'keyword') next.keyword = value || undefined
      this.$router.replace({ path: this.$route.path, query: next }).catch(() => {})
      if (key !== 'view') window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    clearFilters() {
      this.source = 'all'; this.status = ''; this.category = ''; this.visibility = ''; this.mediaType = ''; this.sort = this.defaultSort; this.keyword = ''; this.page = 1
      this.$router.replace({ path: this.$route.path, query: this.viewMode === 'grid' ? {} : { view: this.viewMode } }).catch(() => {})
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    async loadBooks() {
      this.loading = true; this.error = false
      const scope = this.publicOnly ? 'public' : ({ all: 'library', uploads: 'mine', favorites: 'favorite' }[this.source] || 'library')
      try {
        const { data } = await api.book.getBooks({
          scope, status: this.status || undefined, category: this.category || undefined,
          // 「我的上传」总是显式带上可见性（默认 PRIVATE）；其他视图不带，交由后端决定
          visibility: this.source === 'uploads' ? this.visibilitySelect : undefined,
          mediaType: this.mediaType || undefined, sort: this.sort,
          keyword: this.keyword || undefined, page: this.page, pageSize: this.pageSize
        })
        this.books = data.list || []
        this.total = Number(data.total) || 0
        if (this.page > this.totalPages) {
          this.page = this.totalPages
          this.$router.replace({ path: this.$route.path, query: { ...this.$route.query, page: this.page === 1 ? undefined : this.page } }).catch(() => {})
        }
      } catch (error) {
        this.error = true
        this.errorMessage = (error.response && error.response.data && error.response.data.message) || '请检查网络后重试。'
        this.books = []; this.total = 0
      } finally { this.loading = false }
    },
    changePage(page) {
      if (page < 1 || page > this.totalPages) return
      const query = { ...this.$route.query, page: page === 1 ? undefined : String(page) }
      this.$router.push({ path: this.$route.path, query }).catch(() => {})
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    goToDetail(id) { this.$router.push({ name: 'BookDetail', params: { id: String(id) } }) },
    canEdit(book) { return !!(this.$store.state.user && book && book.userId === this.$store.state.user.id) },
    // 我的书库混合了「我的私有书」和「收藏的书」：非本人拥有、或本人但已公开（靠收藏进来的）都可移出
    canRemove(book) {
      if (this.publicOnly) return false
      if (this.source === 'favorites') return true
      if (this.source !== 'all') return false
      const me = this.$store.state.user
      if (!me || !book) return false
      return book.userId !== me.id || book.visibility === 'PUBLIC'
    },
    openEditor(book) { this.currentBook = { ...book }; this.editDialogVisible = true },
    async onEditSuccess() { this.editDialogVisible = false; this.currentBook = null; await this.loadBooks() },
    async deleteBook(book) {
      try {
        await this.$confirm(`删除《${cleanTitle(book.title)}》会永久移除这本书、章节、笔记和阅读进度。`, '删除内容', { confirmButtonText: '删除内容', cancelButtonText: '取消', type: 'warning' })
        await api.book.deleteBook(book.id)
        this.$message.success('内容已删除')
        await this.loadBooks()
      } catch (error) {
        if (error !== 'cancel') this.$message.error((error.response && error.response.data && error.response.data.message) || '删除失败，请重试')
      }
    },
    async removeFromLibrary(book) {
      try {
        await api.favorite.remove(book.id)
        this.$message.success('已从我的书库移除')
        await this.loadBooks()
      } catch (error) { this.$message.error((error.response && error.response.data && error.response.data.message) || '移除失败，请重试') }
    }
  }
}
</script>

<style lang="scss" scoped>
.library-page { padding: 38px 0 48px; }
.page-header { display: flex; align-items: flex-end; justify-content: space-between; gap: 20px; margin-bottom: 28px; }
.page-kicker { color: var(--nr-accent); font-size: 12px; font-weight: 700; letter-spacing: .07em; }
h1 { margin: 5px 0 4px; color: var(--nr-text); font-size: 30px; line-height: 1.25; font-weight: 650; }
.page-header p { margin: 0; color: var(--nr-text-2); font-size: 14px; }
.header-actions { display: flex; gap: 9px; }
.filter-panel { padding: 14px 16px; border: 1px solid var(--nr-border); border-radius: 14px; background: var(--nr-surface); }
.mobile-filter-button { display: none; }
.mobile-filter-backdrop { position: fixed; inset: 0; z-index: 220; display: flex; align-items: flex-end; background: rgba(13,20,15,.48); }
.mobile-filter-sheet { width: 100%; max-height: 88vh; max-height: 88dvh; overflow-y: auto; padding: 9px 18px calc(16px + env(safe-area-inset-bottom)); border: 1px solid var(--nr-border); border-bottom: 0; border-radius: 21px 21px 0 0; outline: none; background: var(--nr-surface); box-shadow: var(--nr-shadow-float); header { position: sticky; top: -9px; z-index: 1; display: flex; align-items: center; justify-content: space-between; margin: -9px -18px 6px; padding: 13px 18px 11px; border-bottom: 1px solid var(--nr-border); background: var(--nr-surface); span { color: var(--nr-accent-text); font-size: 10px; font-weight: 650; letter-spacing: .08em; } h2 { margin: 2px 0 0; color: var(--nr-text); font-size: 19px; } > button { display: grid; width: 38px; height: 38px; place-items: center; color: var(--nr-text-2); border: 0; border-radius: 9px; background: transparent; cursor: pointer; } } footer { position: sticky; bottom: calc(-16px - env(safe-area-inset-bottom)); display: flex; justify-content: space-between; gap: 10px; margin: 16px -18px calc(-16px - env(safe-area-inset-bottom)); padding: 12px 18px calc(12px + env(safe-area-inset-bottom)); border-top: 1px solid var(--nr-border); background: var(--nr-surface); .btn { min-height: 42px; } } }
.sheet-filter-group { padding: 13px 0 10px; border-bottom: 1px solid var(--nr-border); > strong { display: block; margin-bottom: 7px; color: var(--nr-text-2); font-size: 12px; } }
.sheet-selects { display: grid; grid-template-columns: 1fr; gap: 10px; padding: 13px 0 5px; .select-field { display: flex; min-height: 40px; align-items: center; justify-content: space-between; color: var(--nr-text-2); font-size: 12px; } .nr-select { min-width: 150px; max-width: 58%; height: 38px; } }
.mobile-filter-button:focus-visible,.mobile-filter-sheet button:focus-visible,.mobile-filter-sheet select:focus-visible { outline: 3px solid color-mix(in srgb, var(--nr-accent) 35%, transparent); outline-offset: 2px; }
.filter-count { display: inline-grid; min-width: 19px; height: 19px; place-items: center; padding: 0 5px; color: var(--nr-on-accent); border-radius: 99px; background: var(--nr-accent); font-size: 10px; font-weight: 700; }
.filter-row { display: flex; min-height: 42px; align-items: center; gap: 14px; }
.filter-row + .filter-row { margin-top: 8px; padding-top: 8px; border-top: 1px solid var(--nr-border); }
.filter-label { flex: 0 0 52px; color: var(--nr-text-3); font-size: 12px; font-weight: 600; }
.chips { display: flex; flex-wrap: wrap; gap: 6px; }
.filter-chip { min-height: 34px; padding: 0 12px; color: var(--nr-text-2); border: 1px solid transparent; border-radius: 8px; background: transparent; font-size: 13px; cursor: pointer; transition: color 160ms ease, background 160ms ease, border-color 160ms ease;
  &:hover { color: var(--nr-text); background: var(--nr-surface-2); }
  &.active { color: var(--nr-accent-text); border-color: color-mix(in srgb, var(--nr-accent) 25%, transparent); background: var(--nr-accent-bg); font-weight: 650; }
}
.filter-selects { gap: 14px; }
.select-field { display: flex; align-items: center; gap: 8px; }
.select-field .filter-label { flex-basis: auto; }
.select-field .nr-select { width: auto; min-width: 126px; height: 36px; padding: 0 28px 0 10px; font-size: 12px; }
.filter-spacer { flex: 1; }
.view-switch { display: flex; padding: 2px; border: 1px solid var(--nr-border); border-radius: 9px; background: var(--nr-bg); }
.view-switch button { display: grid; width: 34px; height: 32px; place-items: center; color: var(--nr-text-3); border: 0; border-radius: 6px; background: transparent; cursor: pointer; &.active { color: var(--nr-accent-text); background: var(--nr-surface); box-shadow: var(--nr-shadow); } }
.results-bar { display: flex; min-height: 54px; align-items: center; justify-content: space-between; color: var(--nr-text-3); font-size: 12px; }
.clear-filters { min-height: 36px; padding: 0 8px; color: var(--nr-accent-text); border: 0; background: transparent; font-size: 12px; cursor: pointer; &:hover { text-decoration: underline; } }
.library-grid { display: grid; grid-template-columns: repeat(5, minmax(0, 1fr)); gap: 26px 22px; }
.library-grid.as-list { grid-template-columns: 1fr; gap: 10px; }
.state-panel { display: flex; min-height: 122px; align-items: center; gap: 14px; padding: 20px; border: 1px solid var(--nr-border); border-radius: 14px; background: var(--nr-surface); color: var(--nr-text-2); }
.state-panel strong { display: block; color: var(--nr-text); font-size: 14px; }
.state-panel p { margin: 3px 0 0; color: var(--nr-text-2); font-size: 13px; }
.state-panel > .btn { margin-left: auto; }
.empty-mark { display: grid; width: 46px; height: 46px; flex: 0 0 46px; place-items: center; color: var(--nr-accent); border-radius: 13px; background: var(--nr-accent-bg); }
.pager { display: flex; justify-content: center; gap: 6px; margin-top: 36px; }
.pager button { display: grid; min-width: 38px; min-height: 38px; place-items: center; color: var(--nr-text-2); border: 1px solid transparent; border-radius: 8px; background: transparent; cursor: pointer; &:hover:not(:disabled) { background: var(--nr-surface-2); } &:disabled { color: var(--nr-disabled); cursor: default; } &.active { color: var(--nr-on-accent); border-color: var(--nr-accent); background: var(--nr-accent); } }
.cover-skeleton { min-width: 0; }
.cover-skeleton span { display: block; aspect-ratio: 5 / 7; border-radius: 5px; background: var(--nr-skeleton); }
.cover-skeleton i { display: block; height: 10px; margin-top: 10px; border-radius: 5px; background: var(--nr-skeleton); }
.cover-skeleton i:last-child { width: 64%; margin-top: 6px; }

@media (max-width: 1199px) { .library-grid.as-grid { grid-template-columns: repeat(4, minmax(0, 1fr)); } }
@media (max-width: 900px) { .library-grid.as-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); } }
@media (max-width: 767px) {
  .library-page { padding: 27px 0 24px; }
  .page-header { align-items: center; margin-bottom: 20px; }
  h1 { font-size: 25px; }
  .page-header p { max-width: 230px; font-size: 12px; }
  .header-actions .btn { min-width: 40px; padding-inline: 10px; }
  .header-actions .btn span { display: none; }
  .filter-panel { margin: 0 -4px; padding: 11px; }
  .filter-row:not(.media-row) { display: none; }
  .filter-row { gap: 8px; }
  .media-row { min-height: 39px; }
  .media-row .chips { min-width: 0; flex-wrap: nowrap; overflow-x: auto; scrollbar-width: none; }
  .media-row .chips::-webkit-scrollbar { display: none; }
  .mobile-filter-button { display: inline-flex; min-height: 37px; align-items: center; gap: 7px; margin-top: 7px; padding: 0 9px; color: var(--nr-text-2); border: 1px solid var(--nr-border); border-radius: 8px; background: var(--nr-bg); font-size: 11px; cursor: pointer; }
  .filter-label { flex-basis: 48px; font-size: 11px; }
  .filter-chip { flex: 0 0 auto; min-height: 34px; padding-inline: 10px; font-size: 12px; }
  .filter-selects { display: flex; flex-wrap: wrap; }
  .select-field { flex: 1 1 calc(50% - 8px); justify-content: space-between; gap: 5px; }
  .select-field .filter-label { flex-basis: auto; }
  .select-field .nr-select { min-width: 0; max-width: 150px; }
  .filter-spacer { display: none; }
  .view-switch { margin-left: auto; }
  .library-grid.as-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 22px 16px; }
  .state-panel { flex-wrap: wrap; padding: 16px; }
  .pager { margin-top: 24px; }
}
</style>
